import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import Radio from "@mui/material/Radio";
import { useTranslations } from "../../../../providers/useTranslations";
import styles from "./MethodType.module.scss";
export const MethodType = memo(({ method, selectedMethod, isSingleMethod, selectMethod }) => {
    const { __ } = useTranslations();
    const handleMethod = (event) => {
        selectMethod(event.target.value);
    };
    if (isSingleMethod)
        return null;
    return (_jsxs("div", { className: styles.methodTitle, children: [_jsx(Radio, { "data-testid": method.code, color: "primary", classes: {
                    checked: styles.checkedRadio,
                }, value: method.code, className: styles.radioBox, id: method.code, onChange: handleMethod, checked: selectedMethod === method.code }, method.code), _jsx("label", { htmlFor: method.code, children: __(`auth.age_verification.method.${method.code}.title`, [], method.name) })] }));
});
//# sourceMappingURL=MethodType.js.map